import { coverMapping, projectBox } from "../../inference/detector.js";

const STROKE = 2;
const RADIUS = 14;

export function createBoxOverlay(canvas, source) {
  const context = () => canvas.getContext("2d");

  const resize = () => {
    const ratio = globalThis.devicePixelRatio || 1;
    const width = canvas.clientWidth || canvas.width;
    const height = canvas.clientHeight || canvas.height;
    if (canvas.width !== Math.round(width * ratio) || canvas.height !== Math.round(height * ratio)) {
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
    }
    return { width, height, ratio };
  };

  return {
    clear() {
      const { ratio } = resize();
      context().setTransform(ratio, 0, 0, ratio, 0, 0);
      context().clearRect(0, 0, canvas.width, canvas.height);
    },
    draw(dogs, region) {
      const { width, height, ratio } = resize();
      const ctx = context();
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      ctx.clearRect(0, 0, width, height);
      if (!dogs?.length || !width || !height) return 0;
      const sourceWidth = source.videoWidth || source.naturalWidth || source.width;
      const sourceHeight = source.videoHeight || source.naturalHeight || source.height;
      if (!sourceWidth || !sourceHeight) return 0;
      const mapping = coverMapping(sourceWidth, sourceHeight, width, height);
      ctx.lineWidth = STROKE;
      ctx.strokeStyle = "rgba(255, 255, 255, 0.92)";
      ctx.shadowColor = "rgba(0, 0, 0, 0.45)";
      ctx.shadowBlur = 6;
      for (const dog of dogs) {
        const box = projectBox(dog, region, mapping);
        ctx.beginPath();
        ctx.roundRect(box.left, box.top, box.width, box.height, RADIUS);
        ctx.stroke();
      }
      return dogs.length;
    }
  };
}
